import React, { useState } from 'react'
// import PropTypes from 'prop-types'
import Layout from '../../../components/Admin/Layout'
import './CreateLPN.scss'
import InputField from '../../../components/shared/InputField'
import Loading from '../../../components/shared/Loading'
import AdminService from '../../../services/AdminServices'
import SimpleModal from '../../../components/shared/MessageModal'
import helperAdmin from '../../../utils/helperAdmin'
import InputDrag from '../../../components/shared/InputDrag'
import CustomizedBtn from '../../../components/Admin/CustomizedBtn'

const UploadLPN = (props) => {
  const [form, setForm] = useState({
    email: '',
    file: null
  })
  const [loading, setLoading] = useState(false);
  const [openModalSuccess, setModalSuccess] = useState(false);
  const [openModalError, setModalError] = useState(false);
  const [openModalWarning, setModalWarning] = useState(false);

  const handleUpload = async () => {
    try {
      console.log(form);
      setLoading(true);
      const config = {
        onUploadProgress: function(progressEvent) {
          let percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
          console.log(percentCompleted)
        }
      }
      const response = await AdminService.uploadExcelLPN(form, config);
      console.log(response);
      clearValue();
      setLoading(false);
      setModalSuccess(true);
    } catch (error) {
      setLoading(false);
      setModalError(true);
      clearValue();
      console.error(error);
    }
  }

  const clearValue = () => {
    setForm({
      email: '',
      file: null
    })
  }

  const handleChange = async (evt, name) => {
    let value = evt.target ? evt.target.value : evt;
    const key = evt.target ? evt.target.name : name;
    console.log(value, key);
    if (key === 'file') {
      const fileNameDestructured = value.name.split('.');
      const extension = fileNameDestructured[fileNameDestructured.length - 1]
      if(!helperAdmin['supportExcelFiles'].includes(extension)) return setModalWarning(true);
    }
    setForm({
      ...form,
      [key]: value
    })
  }

  return (
    <Layout>
      <div className='uploadLPN-container'>
        <Loading visible={loading} />
        <SimpleModal
          visible={openModalSuccess}
          closeModal={() => setModalSuccess(false)}
          message='Se subió correctamente el archivo excel.'
          type={0}
        />
        <SimpleModal
          visible={openModalWarning}
          closeModal={() => setModalWarning(false)}
          message={`La extensión del archivo debe ser de tipo: ${helperAdmin['supportExcelFiles'].join(', ')}.`}
          type={1}
        />
        <SimpleModal
          visible={openModalError}
          closeModal={() => setModalError(false)}
          message='No se pudo completar la carga. Por favor revise su conexión o el formato del archivo excel.'
          type={1}
        />
        <div className='uploadLPN-title'>Creación de LPNs</div>
        <form>
          <InputDrag
            onDrop={files => handleChange(files[0], 'file')}
            value={form.file}
          />
          <span className='uploadLPN-label' >Enviar archivo a</span>
          <InputField
            name='email'
            value={form.email}
            handleChange={handleChange}
            label='Email'
            fullWidth
            inputType='textfield'
          />
        </form>
        <div className='upload-footer'>
          <CustomizedBtn
            filled={true}
            margin='0'
            onClick={handleUpload}
            disabled={!form.email || !form.file}
            size='large'
          >
            Cargar y enviar
          </CustomizedBtn>
        </div>
      </div>
    </Layout>
  )
}

UploadLPN.propTypes = {

}

export default UploadLPN
